import { Injectable } from "@angular/core";
import { HttpService, SessionService } from "@ecp-caf/caf-common";
import { NotifyService } from "@farris/ui-notify";
import { BusinessObjectRtService } from "@gsp-lcm/bo-rt-service";
import { TranslateService } from "@ngx-translate/core";
import { map } from "rxjs/operators";
import { DocuTypeHelperEntity } from "./entity/DocuTypeHelperEntity";

@Injectable()
export class BillTypeHelpService {
    documentTypeUrl = "/api/runtime/aif/v1.0/documenttype";

    constructor(
        public boRtService: BusinessObjectRtService,
        public httpClient: HttpService,
        public httpService: HttpService,
        public sessionService: SessionService,
        public notify: NotifyService,
        public translate: TranslateService,
    ) {
    }

    findDocumentTypeEntites() {
        const body = {};
        return this.httpService.post(`${this.documentTypeUrl}/docutypehelper`, body).pipe(
            map(
                (res: any) => {
                    return res.map(it => {
                        const e = new DocuTypeHelperEntity();
                        e.LoadFromJsonObject(it);
                        return e;
                    });
                }
            )
        );
    }
}